
import { DataService } from '@/service/DataService';
import { isAdministrator } from '@/utils/functions';
import { LoginProvider, SiteInfo, User } from '@/utils/models';
import { Component, Vue } from 'vue-property-decorator';
@Component({})
export default class SiteinfoView extends Vue {
  siteInfo: SiteInfo = {} as any;
  authLoginProviders: LoginProvider[] = [];
  allowDomainNames = '';
  dataService: DataService | null = null;
  userRegisterTypes = [
    {
      id: 'auto',
      name: '全自動',
      description: '全てのユーザーのログインを許可します。',
    },
    {
      id: 'semi-auto',
      name: '半自動',
      description: '許可するドメインのユーザーを自動でメンバーとして登録します。',
    },
    {
      id: 'manual',
      name: '手動',
      description: 'メンバー登録されていないユーザーはアクセスできません。',
    },
  ];
  showSiteLinkChoices = [
    {
      id: 'yes',
      name: 'Yes',
      description: '「管理メニュー」ボタンの横に「サイトリンク」ボタンを表示します。',
    },
    {
      id: 'no',
      name: 'No',
      description: '「管理メニュー」ボタンの横に「サイトリンク」ボタンを表示しません。',
    },
  ];
  demoSiteChoices = [
    {
      id: 'demo',
      name: 'デモサイト',
      description: 'デモ用の機能を提供します。',
    },
    {
      id: 'normal',
      name: '通常サイト',
      description: '通常のzawaroomの機能を提供します。',
    },
  ];
  siteSuspensionChoices = [
    {
      id: 'open',
      name: '運営中',
      description:
        'サイトを運営状態にします。デモサイトの場合は運営中であっても08:00~20:00以外の時間帯ではクローズします。',
    },
    {
      id: 'suspend',
      name: '一時停止',
      description: 'サイトを一時停止します。',
    },
  ];
  autoRegisterDomainNames = '';
  showTMCAnnouncementChoices = [
    {
      id: 'tmcshow',
      name: '表示する',
      description: 'TMC向けのお知らせを表示します。',
    },
    {
      id: 'tmshide',
      name: '非表示',
      description: 'TMC向けのお知らせを非表示にします。',
    },
  ];
  mounted() {
    this.dataService = this.$store.state.dataService;
    this.siteInfo = { ...this.$store.state.siteInfo };
    this.allowDomainNames = this.siteInfo.allowDomainNames?.join('\r\n') || '';
    this.autoRegisterDomainNames = this.siteInfo.autoRegisterDomainNames?.join('\r\n') || '';

    this.dataService!.emitGetLoginProviders().then((pv) => {
      this.authLoginProviders = pv;
      pv.sort((a, b) => a.sortOrder - b.sortOrder);
    });
  }
  get enableProviders() {
    return this.authLoginProviders.filter((v) => v.enable);
  }
  get canRegieterProviders() {
    return this.enableProviders.filter(
      (v) => v.canRegister && this.$store.state.siteInfo?.authLoginProviders?.includes(v.id),
    );
  }
  get isAdministrator(): boolean {
    return isAdministrator(this.user);
  }
  get user(): User {
    return this.$store.state.user;
  }
  saveSiteInfo() {
    const siteInfo: SiteInfo = this.siteInfo;
    siteInfo.allowDomainNames = this.allowDomainNames.split(/[\s,\t]+/).filter((v) => v);
    siteInfo.autoRegisterDomainNames = this.autoRegisterDomainNames.split(/[\s,\t]+/).filter((v) => v);
    this.$store.commit('SetSiteInfo', siteInfo);
    this.dataService!.emitUpdateSiteInfo(siteInfo);
    this.$toast.info('更新しました。');
  }
  onSiteTypeChange(event: Event) {
    this.siteInfo.isDemo = (event.target as HTMLInputElement).value === 'demo';
  }
  onSiteOpenOrSuspend(event: Event) {
    this.siteInfo.suspended = (event.target as HTMLInputElement).value === 'suspend';
  }
  onShowTMCAnnouncementChange(event: Event) {
    this.siteInfo.showTMCAnnouncement = (event.target as HTMLInputElement).value === 'tmcshow';
  }
}
